import React from 'react';
import Banner from '../../../Banner/Banner';
import Footer from '../../../Footer/Footer';
import TopPlayer from '../../../TopPlayer/TopPlayer';

const Home = () => {
    return (
        <>
       
         <Banner/>
         <TopPlayer/>
         <Footer/>

        </>
    );
};

export default Home;